import React from 'react';
import { Reveal } from './Reveal';
import { CTAButton } from './CTAButton';
import { previewItems } from '../data/previewItems';
export function PreviewSection() {
  return <section aria-labelledby="preview-title" className="bg-cream px-5 py-20 md:py-28" data-id="element-175" data-mp="223zfmeq140kt">
      <Reveal className="mx-auto max-w-content" data-id="element-176" data-mp="226bswekudmrj">
        <div className="mx-auto max-w-2xl text-center" data-id="element-177" data-mp="2720x4v7t3ru6">
          <p className="text-[11px] font-bold uppercase tracking-[0.18em] text-amber" data-id="element-178" data-mp="1se63nclz5jg1">INSIDE THE VOLUMES</p>
          <h2 id="preview-title" className="mt-4 text-3xl font-extrabold tracking-tight text-pine md:text-4xl" data-id="element-179" data-mp="1x4mgauhz111c">
            See Exactly What You Get. Really.
          </h2>
          <p className="mt-4 text-slate-body" data-id="element-180" data-mp="1jbepv65mmbl8">Real pages from the volumes. Nothing staged.</p>
        </div>
        <ul className="mt-12 grid gap-6 sm:grid-cols-2 md:grid-cols-3" data-id="element-181" data-mp="1ncqgnf08l2v0">
          {previewItems.map(({
          image,
          alt,
          caption
        }) => <li key={caption} className="rounded-card bg-white p-3 shadow-lift" data-id="element-182" data-mp="1eexzs6ev9n5i">
              <div className="overflow-hidden rounded-[12px] bg-[#F4F1EA]" data-id="element-183" data-mp="2crrbaj3usjzq">
                <img src={image} alt={alt} loading="lazy" className="aspect-[3/5] w-full object-contain" data-id="element-184" data-mp="2cu3zvf449slr" />
              </div>
              <p className="px-2 pb-1 pt-3.5 text-center text-xs font-medium leading-snug text-slate-body" data-id="element-185" data-mp="2gtl98jmnz9w7">
                {caption}
              </p>
            </li>)}
        </ul>
        <div className="mt-12 flex justify-center" data-id="element-186" data-mp="1t1nvgmznm7sg">
          <CTAButton className="w-full max-w-md md:w-auto" data-id="element-187" data-mp="1p3q87ppg1vrp" />
        </div>
      </Reveal>
    </section>;
}